import { Carousel } from "antd";
import { color } from "src/styles/globals";
import { down } from "styled-breakpoints";
import styled from "styled-components";

export const LeftArrowIcon = styled.div<{ size: number; margin: number }>`
  margin-left: ${(props) => props.margin}px;
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  border: 1px solid ${color.charcoal03};
  border-radius: 50%;
  background-color: ${color.white};
  display: flex;
  align-items: center;
  justify-content: center;

  :hover {
    cursor: pointer;
  }
  ${down("md")} {
    display: none;
  }
`;
export const RightArrowIcon = styled.div<{ size: number; margin: number }>`
  margin-right: ${(props) => props.margin}px;
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  border: 1px solid ${color.charcoal03};
  border-radius: 50%;
  background-color: ${color.white};
  display: flex;
  align-items: center;
  justify-content: center;

  :hover {
    cursor: pointer;
  }
  ${down("md")} {
    display: none;
  }
`;

export const DesktopCarousel = styled(Carousel)<{
  activeDotColor: string;
  inactiveDotColor: string;
  slickDotMarginTop: number;
  width: number;
}>`
  width: ${(props) => props.width}px;
  > .slick-dots {
    margin: 0px 4px;
  }
  > .slick-dots li {
    width: 8px;
    margin: 0px 4px;
  }
  > .slick-dots li.slick-active {
    width: 32px;
    margin: 0px 4px;
  }
  > .slick-dots li button {
    margin-top: ${(props) => props.slickDotMarginTop}px;
    opacity: 1;
    border-radius: 5px;
    width: 8px;
    height: 8px;
    background: ${(props) => props.inactiveDotColor};
  }
  > .slick-dots li.slick-active button {
    border-radius: 5px;
    width: 32px;
    height: 8px;
    background: ${(props) => props.activeDotColor};
  }
  > .slick-dots li button::before {
    display: none;
  }
  > .slick-dots li.slick-active button::before {
    display: none;
  }
`;

export const MobileCarousel = styled(Carousel)<{
  activeDotColor: string;
  slickDotMarginTop: number;
  inactiveDotColor: string;
}>`
  max-width: 359px;
  > .slick-dots {
    margin: 0px 4px;
  }
  > .slick-dots li {
    width: 8px;
    margin: 0px 4px;
  }
  > .slick-dots li.slick-active {
    width: 32px;
    margin: 0px 4px;
  }
  > .slick-dots li button {
    margin-top: ${(props) => props.slickDotMarginTop}px;
    opacity: 1;
    border-radius: 5px;
    width: 8px;
    height: 8px;
    background: ${(props) => props.inactiveDotColor};
  }
  > .slick-dots li.slick-active button {
    border-radius: 5px;
    width: 32px;
    height: 8px;
    background: ${(props) => props.activeDotColor};
  }
  > .slick-dots li button::before {
    display: none;
  }
  > .slick-dots li.slick-active button::before {
    display: none;
  }
`;
